import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {Navbar} from "../userfolder/Navbar";
import { FaUser, FaLock, FaPhone, FaLocationArrow , } from "react-icons/fa";

const Signup = () => {
  const [formData, setFormData] = useState({ name: "", email: "", password: "", cpassword: "", mobile: "", pincode: "", area: "" });
  const nav = useNavigate();
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("/agent/signup", formData);
      alert("Signup Successful! Please Login.");
      nav('/login');
    } catch (error) {
      console.error("Signup Error", error.response.data);
      alert("USER ALREADY EXISTS");
    }
  };

  return (
    <div className="login-page pt-5">
          <Navbar />
    <div className="login-container mt-5">
      <h2 className="login-title">Agent Signup</h2>
      <form className="login-form" onSubmit={handleSubmit}>
         <div className="input-container">
                  <FaUser className="input-icon" />
        <input type="text" name="name" placeholder="Name" onChange={handleChange} required className="login-input" /></div>
        <div className="input-container">
                  <FaUser className="input-icon" />
        <input type="email" name="email" placeholder="Email" onChange={handleChange} required className="login-input"/> </div>
        <div className="input-container">
                  <FaLock className="input-icon" />
        <input type="password" name="password" placeholder="Password" onChange={handleChange} required className="login-input"/> </div>
        <div className="input-container">
                  <FaLock className="input-icon" />
        <input type="password" name="cpassword" placeholder="confirm Password" onChange={handleChange} required className="login-input"/> </div>
        <div className="input-container">
                  <FaPhone className="input-icon" />
        <input type="text" name="mobile" placeholder="mobile number" onChange={handleChange} require className="login-input" /> </div>
        <div className="input-container">
                  <FaLocationArrow className="input-icon" />
        <input type="text" name="pincode" placeholder="Enter Pincode" onChange={handleChange} required className="login-input"/> </div>
        <div className="input-container">
                  <FaLocationArrow className="input-icon" />
        <input type="text" name="area" placeholder="area" onChange={handleChange} required className="login-input" />   </div>
        <button type="submit"  className="login-button">Signup</button>
      </form>
    </div>
    </div>
  );
};

export default Signup;
